// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/filteringAndSorting/index.md?type=frontmatter';
import { demoIndex as dmi0 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/filteringAndSorting/index.md?type=demo-index';
import { frontmatter as fm1, toc as t1 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/mergeRowsAndColumns/index.md?type=frontmatter';
import { demoIndex as dmi1 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/mergeRowsAndColumns/index.md?type=demo-index';
import { frontmatter as fm2, toc as t2 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/disabledAndShow/index.md?type=frontmatter';
import { demoIndex as dmi2 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/disabledAndShow/index.md?type=demo-index';
import { frontmatter as fm3, toc as t3 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/rowSelection/index.md?type=frontmatter';
import { demoIndex as dmi3 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/rowSelection/index.md?type=demo-index';
import { frontmatter as fm4, toc as t4 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/deployable/index.md?type=frontmatter';
import { demoIndex as dmi4 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/deployable/index.md?type=demo-index';
import { frontmatter as fm5, toc as t5 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/readonly/index.md?type=frontmatter';
import { demoIndex as dmi5 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/readonly/index.md?type=demo-index';
import { frontmatter as fm6, toc as t6 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/formEle/index.md?type=frontmatter';
import { demoIndex as dmi6 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/formEle/index.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/operate/index.md?type=frontmatter';
import { demoIndex as dmi7 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/operate/index.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/custom/index.md?type=frontmatter';
import { demoIndex as dmi8 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/custom/index.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/layout/index.md?type=frontmatter';
import { demoIndex as dmi9 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/layout/index.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/check/index.md?type=frontmatter';
import { demoIndex as dmi10 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/check/index.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/fixed/index.md?type=frontmatter';
import { demoIndex as dmi11 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/fixed/index.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/watch/index.md?type=frontmatter';
import { demoIndex as dmi12 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/watch/index.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/base/index.md?type=frontmatter';
import { demoIndex as dmi13 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/base/index.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/design/index.md?type=frontmatter';
import { demoIndex as dmi14 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/design/index.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/changelog.md?type=frontmatter';
import { demoIndex as dmi15 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/changelog.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/introduc.md?type=frontmatter';
import { demoIndex as dmi16 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/introduc.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/index.md?type=frontmatter';
import { demoIndex as dmi17 } from '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/index.md?type=demo-index';

export const filesMeta = {
  'pages/pages/reference/filteringAndSorting/index': {
    frontmatter: fm0,
    toc: t0,
    demoIndex: dmi0,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/filteringAndSorting/index.md?type=text'),
  },
  'pages/pages/reference/mergeRowsAndColumns/index': {
    frontmatter: fm1,
    toc: t1,
    demoIndex: dmi1,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/mergeRowsAndColumns/index.md?type=text'),
  },
  'pages/pages/reference/disabledAndShow/index': {
    frontmatter: fm2,
    toc: t2,
    demoIndex: dmi2,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/disabledAndShow/index.md?type=text'),
  },
  'pages/pages/reference/rowSelection/index': {
    frontmatter: fm3,
    toc: t3,
    demoIndex: dmi3,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/rowSelection/index.md?type=text'),
  },
  'pages/pages/reference/deployable/index': {
    frontmatter: fm4,
    toc: t4,
    demoIndex: dmi4,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/deployable/index.md?type=text'),
  },
  'pages/pages/reference/readonly/index': {
    frontmatter: fm5,
    toc: t5,
    demoIndex: dmi5,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/readonly/index.md?type=text'),
  },
  'pages/pages/reference/formEle/index': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/formEle/index.md?type=text'),
  },
  'pages/pages/reference/operate/index': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/operate/index.md?type=text'),
  },
  'pages/pages/reference/custom/index': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/custom/index.md?type=text'),
  },
  'pages/pages/reference/layout/index': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/layout/index.md?type=text'),
  },
  'pages/pages/reference/check/index': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/check/index.md?type=text'),
  },
  'pages/pages/reference/fixed/index': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/fixed/index.md?type=text'),
  },
  'pages/pages/reference/watch/index': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/watch/index.md?type=text'),
  },
  'pages/pages/reference/base/index': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/base/index.md?type=text'),
  },
  'pages/design/index': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/design/index.md?type=text'),
  },
  'pages/changelog': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/changelog.md?type=text'),
  },
  'pages/introduc': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/introduc.md?type=text'),
  },
  'pages/index': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/index.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
